import React, { ReactNode, createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../lib/apiCall';
import { socket } from '../components/navegacao/socket';
import { AtendimentoNotificacoesProvider } from '@/contexts/AtendimentoNotificacoesContext';
import ChatInterno from './ChatInterno';
import AvisoAtualizacaoSistema from './AvisoAtualizacaoSistema';

interface AuthWrapperProps {
  children: ReactNode;
}

/** Marca própria da organização exibida na sidebar (whitelabel). */
export interface OrganizacaoMarca {
  nome_fantasia?: string | null;
  tem_logo?: boolean;
}

export interface AuthState {
  user: any;
  setUser: (user: any) => void;
  loading: boolean;
  organizacao?: OrganizacaoMarca;
}

const nullSet = (user: any) => {
  console.warn('setUser not initialized');
}

export const AuthContext = createContext({ user: null, setUser: nullSet, loading: true });

const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const [auth, setAuth] = useState<AuthState>({ user: null, setUser: nullSet, loading: true });

  const updUser = (user: any) => {
    setAuth(prev => ({ ...prev, user }));
  }

  useEffect(() => {
    api
      .get('/api/auth/me')
      .then(response => {
        setAuth({
          user: response.data.user,
          organizacao: response.data.organizacao,
          setUser: updUser,
          loading: false,
        });
      })
      .catch(error => {
        if (error.response?.status === 404 && error.config?.url?.includes('/api/auth/me')) {
          window.location.replace('/not-found');
          return new Promise(() => { });
        }
        console.error(error);
        setAuth({ user: null, setUser: nullSet, loading: false });
      });
  }, []);
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.loading && !auth.user) {
      // Garante que o websocket não fique tentando reconectar sem sessão
      try {
        socket.disconnect();
      } catch (e) {
        // noop
      }
      navigate(
        '/login?r=' +
        encodeURIComponent(window.location.pathname + window.location.search),
      );
    }
  }, [auth.user, auth.loading, navigate]);

  // Garante reconexão do socket após autenticação
  useEffect(() => {
    if (!auth.loading && auth.user) {
      if (!socket.connected) {
        try {
          socket.connect();
        } catch (e) {
          // noop
        }
      }
    }
  }, [auth.loading, auth.user]);

  if (auth.loading)
    return (
      <div
        style={{
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <img src="/logo.png" alt="Logo Terachat" />
          <div style={{ fontSize: '32px', color: 'var(--tc-color-secondary)' }}>
            Carregando...
          </div>
        </div>
      </div>
    );

  return (
    <AuthContext.Provider value={auth}>
      <AtendimentoNotificacoesProvider>
        {children}
        <ChatInterno />
        <AvisoAtualizacaoSistema />
      </AtendimentoNotificacoesProvider>
    </AuthContext.Provider>
  );
};

export default AuthWrapper;
